import { FC } from 'react';
import styled from 'styled-components';

interface Props {
    itemHeight: number;
    buttonPosition: string;
    className: string;
    onClick: () => void;
}

interface ButtonProps {
    buttonPosition: string;
}
const Button = styled.button<ButtonProps>`
    ${props => props.buttonPosition === 'bottom' && { bottom: '20px' }}

    ${props =>
        props.buttonPosition === 'top' && {
            top: '20px'
        }}
        ${props =>
        !props.buttonPosition && {
            '-webkit-transform': 'translateY(-50%)',
            transform: 'translateY(-50%)',
            top: '50%'
        }}
`;

interface ButtonWrapperProps {
    disabled?: boolean;
    itemHeight?: number;
}

const ButtonWrapper = styled.div<ButtonWrapperProps>`
    display: ${props => props.disabled && 'none'};
    height: ${props => props.itemHeight && `${props.itemHeight}px`};
    top: ${props => props.itemHeight && '0'};
`;
export const SliderButton: FC<Props> = props => {
    return (
        <ButtonWrapper {...props}>
            <div className="shadow" />
            <Button {...props} onClick={props.onClick}>
                <i />
            </Button>
        </ButtonWrapper>
    );
};

export const LeftNavButton = props => {
    return <SliderButton className="slider-prev" aria-label="Previous" {...props} />;
};

export const RightNavButton = props => {
    return <SliderButton className="slider-next" aria-label="Next" {...props} />;
};
